import axios from "axios";
const BACKENDS = {
  skillanthem: "https://us-central1-skillanthem-server.cloudfunctions.net/api/api",
  dev: "http://localhost:8000/api",
};

// read preference (default to skillanthem if not set)
const preference = "skillanthem";
// const preference = "dev";

const instance = axios.create({
  baseURL: BACKENDS[preference],
});

// helper to switch at runtime
export const setBackendPreference = (key) => {
  if (BACKENDS[key]) {
    localStorage.setItem("backend_preference", key);
    instance.defaults.baseURL = BACKENDS[key];
  } else {
    console.warn("Invalid backend key:", key);
  }
};

export default instance;